export const ORDER_QUANTITY_OPTIONS = [
  ...Array.from({ length: 50 }, (_, i) => ({ label: String(i + 1), value: String(i + 1) })),
  { label: "100", value: "100" },
  { label: "250", value: "250" },
  { label: "500", value: "500" },
  { label: "1000", value: "1000" },
  { label: "2500", value: "2500" },
  { label: "5000", value: "5000" },
];
